import { format, isToday } from 'date-fns';

export const formatMsgTime = (ts) => {
	if (!ts) return '';
	if (isToday(ts)) return format(ts, 'HH:mm');
	return format(ts, 'd MMM · HH:mm');
};
